export enum ToastMessageType {
    INFO = 'info',
    SUCCESS = 'success',
    ERROR = 'error',
    SIGNAL = 'signal',
    NEUTRAL = 'neutral',
}
